import { Link } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import type { Idioma } from '../../../i18n/index.js';
import type { FalloDeAthena } from '../../../common/services/api.js';
import { FormularioRegistro } from '../pages/IniciarSesionPage.js';

const TEXTOS = {
  es: {
    titulo: 'Regístrate en Athena para seguir preguntando',
    subtitulo:
      'El número de preguntas sin registro está limitado para evitar abusos por parte de bots y otros usuarios. Una vez registrado tendrás acceso a mucha más cuota diaria y podrás usar Athena a través de nuestro MCP.',
    cerrar: 'Cerrar',
  },
  en: {
    titulo: 'Register with Athena to keep asking questions',
    subtitulo:
      'The number of questions without an account is limited to prevent abuse by bots and other users. Once registered, you will have a much larger daily allowance and can use Athena through our MCP.',
    cerrar: 'Close',
  },
};

export function RegistroLimiteModal({ idioma, fallo }: { readonly idioma: Idioma; readonly fallo: FalloDeAthena | null }) {
  const [abierto, setAbierto] = useState(false);
  const dialogo = useRef<HTMLDialogElement>(null);
  const volver = `${window.location.pathname}${window.location.search}`;
  const t = TEXTOS[idioma];
  useEffect(() => {
    const elemento = dialogo.current;
    if (elemento === null) return;
    if (fallo?.cuotaAnonimaAgotada === true || fallo?.tipo === 'tope_de_gasto_anonimo') {
      setAbierto(true);
      if (!elemento.open) elemento.showModal();
    } else if (elemento.open) {
      elemento.close();
      setAbierto(false);
    }
  }, [fallo]);

  return (
    <dialog
      ref={dialogo}
      onClose={() => setAbierto(false)}
      aria-labelledby='registro-limite-titulo'
      aria-describedby='registro-limite-subtitulo'
      className='fixed inset-0 m-auto max-h-[calc(100dvh-32px)] w-[calc(100%-32px)] max-w-[560px] overflow-y-auto rounded-2xl border border-(--line-strong) bg-(--paper) p-0 text-(--ink) shadow-2xl backdrop:bg-black/65'
    >
      <div className='relative px-6 py-8 sm:px-10 sm:py-10'>
        <button
          type='button'
          aria-label={t.cerrar}
          onClick={() => dialogo.current?.close()}
          className='absolute top-3 right-3 flex size-9 cursor-pointer items-center justify-center rounded-full text-[25px] text-(--ink-soft) hover:bg-(--chat-bg)'
        >
          ×
        </button>
        <h2 id='registro-limite-titulo' className='mt-0 mb-4 pr-3 font-(family-name:--serif) text-[30px] leading-tight font-bold'>
          {t.titulo}
        </h2>
        <p id='registro-limite-subtitulo' className='mt-0 mb-7 font-(family-name:--text) text-[15px] leading-relaxed text-(--ink-soft)'>
          {t.subtitulo}
        </p>
        {abierto ? <FormularioRegistro idioma={idioma} volver={volver} /> : null}
        <Link to={`/iniciar-sesion?volver=${encodeURIComponent(volver)}`} className='mt-5 block text-center text-[14px] text-(--teal-deep) underline'>
          {idioma === 'es' ? 'Ya tengo cuenta. Iniciar sesión' : 'Already have an account? Log in'}
        </Link>
      </div>
    </dialog>
  );
}
